export const es = {
  HEADING:"Integrations",
  ADVANCED_SETTINGS:"Advanced Settings (Fields/Custom Fields)",
  APP_TO_CONNECT:"App(s) that are currently connected to your easywebinar account",
  INTEGRATE_EVENT:"Integrate your webinar with ",
  SUPERCHARGE:"to supercharge your event.",
  CONNECTED:"Connected",
  ACTIVE:"Ready",
  CONNECT_WITH_WEBINAR:"Connect to Webinar",
  NOT_CONNECTED_APPS:"You haven't connected any 3rd party softwares yet.  See our list of CRM Partners below.",
  NOT_CONNECTED_HEADING:"No CRM Activated",
  AVAILABLE_APPS_EASYWEBINAR:"Available softwares to integrate directly with Easywebinar:",
  CONNECT_WITH_APP:"Connect Now!",
  TRY_SEARCHING:"Is your software not on the list? Try using",
  ZAPIER:"Zapier",
  NEW_APPLICATION_INTEGRATIONS:" - or submit a request for a new software integration.",
  OR:" - or ",
  SOFTWARE_INTEGRATIONS:" a new software integration.",
  SUBMIT_REQUEST_LINK:"submit a request",
  SUBMIT_REQUEST:"Submit a Request",
  SELECT:"Select a",
  CONTACT_LIST:"Contact List",
  MODIFICATIONS_MADE_TO_OFFER:"Your attendees will be automatically added to this list after they register to your webinar.",
  CONTINUE:"Continue",
  ARE_YOU_SURE:"Confirmation Required!",
	DELETE_THESE_RECORDS:"Do you really want to remove this item?", 
	UNDONE_MESSAGE:"This process cannot be undone.",
	CHANGES_NOT_SAVED:"Changes not saved!",
	EXIT_MESSAGE:"Are you sure you want to exit!",
	NO:"No",
	YES:"Yes",
  INTEGRATIONS:"Integration",
  CHANGE:"Change",
  CHANGE_INTEGRATION:"Change Integration",
  DISCONNECT:"Disconnect",
  SETTINGS:"settings",
  RELOAD_TAGS:"Reload Tags",
  ACTIONS:"Actions",
  IF:"IF",
  THEN:"THEN",
  ACTION_VALUE:"ACTION/VALUE",
  EDIT:"Edit",
  DELETE:"Delete",
  SELECT_OFFER:"SELECT OFFER",
  ACTION:"ACTION/VALUE",
  DEFAULT:"Default",
  CUSTOM_FORM_FIELDS:"Custom Form Fields",
  ADD_NEW_ACTION:"Add Action",
  WEBINAR_JOIN_LINK:"Webinar Join Link",
  WEBINAR_JOIN_LINK_ATTENDEE:"Assign a custom field from your CRM to save this data.",
  WEBINAR_JOIN_SHORT_LINK:"Webinar Short Link",
  EVENT_SHORT_LINK:"Assign a custom field from your CRM to save this data.",
  WEBINAR_REPLAY_LINK:"Webinar Replay Link",
  WEBINAR_REPLAY_LINK_ATTENDEE:"Assign a custom field from your CRM to save this data.",
  WEBINAR_REPLAY_SHORT_LINK:"Replay Short Link",
  REPLAY_SHORT_LINK:"Assign a custom field from your CRM to save this data.",
  PHONE_NUMBER:"Phone Number",
  PHONE_NUMBER_ATTENDEE:"Assign a custom field from your CRM to save this data.",
  SAVE_CHANGES:"Save Changes",
  WEBINAR_DATE:"Webinar Date",
  ADD_NAME_CUSTOM_FIELD:"Assign a custom field from your CRM to save this data.",
  WEBINAR_TIME:"Webinar Time",
  SAVE_WEBINAR_TIME:"Assign a custom field from your CRM to save this data.",
  WEBINAR_DATE_TIME:"Webinar Date&Time",
  WEBINAR_DATE_TIME_CUSTOM:"Assign a custom field from your CRM to save this data.",
  WEBINAR_TIMEZONE:"Webinar Timezone",
  WEBINAR_TIMEZONE_CUSTOM:"Assign a custom field from your CRM to save this data.",
  WEBINAR_AFFILIATE:"Webinar Affiliate",
  NAME_OF_HIDDEN_FIELD:"Assign a custom field from your CRM to save this data.",
  CUSTOM_FIELD:"Assign a custom field from your CRM to save this data.",
  NO_CUSTOM_FIELD:"There are no custom-fields found for your webinar registration",
  SAVE:"SAVE",
  CONFIRM:"CONFIRM",
  SELECT_CUSTOM_FIELD:"Select a custom field",
  CUSTOM_FORMFIELD_EMAIL:"Assign a custom field from your CRM to save this data.",
  CUSTOM_FORMFIELD_FULLNAME:"Assign a custom field from your CRM to save this data.",
  AWEBER_LIST:"You need to set up your custom fields again",
  SEARCH:"Search",
  Empty_SEARCH:"No entry matches",
  SEARCHLISTDROPDOWNTEXT:"Search",
  SEARCHTAGDROPDOWNTEXT:"Search",
  SNACKBAR_TEXT:{
    DATA_SAVED_SUCC_MSG:"Your data is saved successfully",
    DATA_UPDATED_SUCC_MSG:"Your data is updated successfully",
    SOMETHING_WENT_WRONG:"Something went wrong.Please try again.", 
    SELECT_OFFER_FIRST:"Please select offer first.",   
    SELECT_GDPR_FIRST:"Please select GDPR settings first",   
    USE_DIFFERENT_LIST_FOR_GDPR:"Please select different value as this is already used",   
    SELECT_DIFFRENT:"Please select different value as this is selected for GDPR",   
    REQUIRED_FIELDS_MSG:"All fields are mandatory.",
    GOT_IT_BUTTON:"Got It" 
  },
EVENTS:{
  GDPR_EXCLUDE_LIST:"GDPR exclude list",
  REGISTERED:"Registered",
  ATTENDED:"Attended",
  MISSED:"Missed",
  WATCHED_REPLAY:"Watched replay",
  DID_NOT_WATCHED_REPLAY:"Didn't watch replay",
  JOIN_WEBINAR_AFTER:"Joined webinar after",
  LEFT_WEBINAR_BEFORE:"Left webinar before",
  LEFT_EARLY:"Left early",
  STAY_ON_WEBINAR_AT_LEAST:"Stayed on webinar at least",
  WATCHED_FULL:"Watched full",
  OFFER_CLICKED:"Clicked Offer",
  SAW_BUT_NOT_CLICKED:"Saw offer but didn't click",
  QUESTION_ASKED:"Question asked"  
},
SELECT_ACTIONS:{
ADDTAG: "Add tag",
REMOVETAG: "Remove tag",
ADDTOLIST:"Add to list",
REMOVE_FROM_LIST: "Remove from list"
}
};